
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ort/[slug]",
      function () {
        return require("private-next-pages/ort/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ort/[slug]"])
      });
    }
  